<template>
  <div
    :class="$style.base"
    @click="expand"
    v-test="'nav-expand'"
  >
    <BaseIcon
      :name="isNavExpanded ? 'arrow-left' : 'arrow-right'"
      color="inverted"
      size="s"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { usePageLayoutStore } from '@/stores/page-layout';

const { isNavExpanded } = storeToRefs(usePageLayoutStore());

const expand = () => {
  isNavExpanded.value = !isNavExpanded.value;
};
</script>

<style
  lang="scss"
  module
>
.base {
  position: absolute;
  bottom: 150px;
  right: -7px;
  width: 21px;
  height: 21px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--highlight-inverted-strong);

  @include theme('light') {
    background-color: var(--color-primary);
  }

  @include hover('light') {
    background-color: var(--color-primary-dark);
  }

  @include theme('dark') {
    background-color: var(--surface-primary);
  }

  @include hover('dark') {
    background-color: var(--surface-primary);
  }
}
</style>
